export default "__VITE_PUBLIC_ASSET__59966fd3__"